import * as React from "react";
import { useEffect } from "react";
import type { FC } from "react";

import { ChangeLastRowHeightHandler } from "../../../Internals/ControlContexts/MultilineRowHeightContext";
import { useUUID } from "../../../../../../Common/UUID";

interface EmptyRowProps {
    height: number;
    isView: boolean;
    onHeightChange?: ChangeLastRowHeightHandler;
}

export const EmptyRow: FC<EmptyRowProps> = props => {
    const id = useUUID();

    useEffect(() => {
        if (!props.isView) {
            props.onHeightChange?.({ rowId: id, rowHeight: 0 });
        }
    }, [props.isView]);

    useEffect(() => {
        if (props.isView) {
            props.onHeightChange?.({ rowId: id, rowHeight: props.height });
        }
    }, [props.height, props.isView]);

    return props.isView ? <tr style={{ height: props.height }} /> : <tr />;
};
